"use client";

import { useId, useState } from "react";
import { LandingSection } from "./section";
import { DZPlus } from "./icons";

const FAQS = [
  {
    q: "Is Delta-X free?",
    a: "Yes — everything is free, with no account required. Compare firms, read the research, take the Academy, and use the tools without signing up or paying.",
  },
  {
    q: "Which prop firms do you track?",
    a: "We currently track five futures prop firms in depth and compare them side by side: Topstep, Tradeify, Lucid Trading, Nexgen ProTrader Funding, and Imperial Trader Funding.",
  },
  {
    q: "How do you rank firms?",
    a: "Rankings are editorial and based on how verifiable each firm is from its public documents (our Verification Confidence Score), not on advertised profits. Featured placements are paid and clearly labeled; they never change the editorial ranking.",
  },
  {
    q: "Where does the data come from?",
    a: "Every figure is parsed from each firm's own published rulebook. A nightly scrape re-checks those pages and any verified change is published to the rule-change feed.",
  },
  {
    q: "Do you earn affiliate commissions?",
    a: "Yes, and we disclose it. When you sign up with a firm through our links we may earn a commission. It does not change our rankings or the rules we report.",
  },
];

function FaqItem({
  q,
  a,
  defaultOpen,
}: {
  q: string;
  a: string;
  defaultOpen?: boolean;
}) {
  const [open, setOpen] = useState(!!defaultOpen);
  const panelId = useId();
  return (
    <div className="border-t border-white/[0.06]">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-controls={panelId}
        className="w-full text-left bg-transparent border-0 py-6 flex items-center justify-between gap-6 cursor-pointer text-white"
      >
        <span className="text-[18px] font-medium" style={{ letterSpacing: "-0.01em" }}>
          {q}
        </span>
        <span
          aria-hidden="true"
          className="inline-flex items-center justify-center size-8 rounded-full border transition-colors flex-shrink-0"
          style={{
            borderColor: open ? "rgba(202,255,44,0.3)" : "rgba(255,255,255,0.08)",
            background: open ? "rgba(202,255,44,0.06)" : "transparent",
            color: open ? "var(--brand)" : "var(--fg-dim)",
          }}
        >
          <DZPlus size={12} open={open} />
        </span>
      </button>
      <div id={panelId} className="dz-faq-panel" data-open={open}>
        <p className="m-0 text-[15px] leading-[1.65] text-[var(--fg-dim)] max-w-[760px] text-pretty">
          {a}
        </p>
      </div>
    </div>
  );
}

export function FaqSection() {
  return (
    <LandingSection
      id="learn"
      eyebrow="Frequently Asked"
      title="Questions traders ask before pulling the trigger."
    >
      <div className="border-b border-white/[0.06]">
        {FAQS.map((f, i) => (
          <FaqItem key={f.q} q={f.q} a={f.a} defaultOpen={i === 0} />
        ))}
      </div>
    </LandingSection>
  );
}
